<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">I would like to thank Glynis, Susan and Deb, who gave me encouragement along the way.</p><br/>
<p style="text-align: center;">Also, to Perry, who read it first and stayed up all night to finish it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?31409d40